module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "50px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 text-center",
    staticStyle: {
      "font-size": "32px",
      "font-weight": "bold"
    }
  }, [(_vm.type) ? _c('img', {
    attrs: {
      "src": "images/ajanlat_header.jpg",
      "width": "100%",
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "src": "images/szobafoglalas_header.jpg",
      "width": "100%",
      "alt": ""
    }
  })])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row panorama-row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.object.name),
      expression: "object.name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.object.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.object, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row panorama-row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.object.phone),
      expression: "object.phone"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.object.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.object, "phone", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row panorama-row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.object.email),
      expression: "object.email"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.object.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.object, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row panorama-row"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('datepicker', {
    attrs: {
      "format": "yyyy. MM. dd.",
      "language": _vm.hu
    },
    model: {
      value: (_vm.object.arrive),
      callback: function($$v) {
        _vm.$set(_vm.object, "arrive", $$v)
      },
      expression: "object.arrive"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row panorama-row"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('datepicker', {
    attrs: {
      "format": "yyyy. MM. dd.",
      "language": _vm.hu
    },
    model: {
      value: (_vm.object.leave),
      callback: function($$v) {
        _vm.$set(_vm.object, "leave", $$v)
      },
      expression: "object.leave"
    }
  })], 1)]), _vm._v(" "), (!_vm.type) ? _c('div', {
    staticClass: "row panorama-row"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.object.roomNum),
      expression: "object.roomNum"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.object.roomNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.object, "roomNum", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (!_vm.type) ? _c('div', {
    staticClass: "row panorama-row"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.object.roomType),
      expression: "object.roomType"
    }],
    staticStyle: {
      "width": "100%"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.object, "roomType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "default": ""
    },
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Kérem válasszon!")]), _vm._v(" "), _c('option', [_vm._v("Kétágyas")]), _vm._v(" "), _c('option', [_vm._v("Franciaágyas")]), _vm._v(" "), _c('option', [_vm._v("Apartman")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row panorama-row"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.object.adultNum),
      expression: "object.adultNum"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.object.adultNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.object, "adultNum", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row panorama-row"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.object.childrenNum),
      expression: "object.childrenNum"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.object.childrenNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.object, "childrenNum", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row panorama-row"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.object.childrenAge),
      expression: "object.childrenAge"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.object.childrenAge)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.object, "childrenAge", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row panorama-row"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.object.comment),
      expression: "object.comment"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "rows": "4"
    },
    domProps: {
      "value": (_vm.object.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.object, "comment", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row panorama-row"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "width": "50px",
      "transform": "scale(1.5)"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.aszf),
      expression: "aszf"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.aszf) ? _vm._i(_vm.aszf, null) > -1 : (_vm.aszf)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.aszf,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.aszf = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.aszf = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.aszf = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row panorama-row"
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('button', {
    staticClass: "my-button",
    staticStyle: {
      "background-image": "url('images/aranysav.jpg')",
      "font-size": "28px",
      "width": "200px"
    },
    on: {
      "click": function($event) {
        _vm.send()
      }
    }
  }, [_vm._v("Küldés")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "font-size": "22px",
      "font-weight": "bold",
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [(_vm.type) ? _c('span', [_vm._v("Az ajánlatkérés nem minősül szobafoglalásnak!")]) : _c('span', [_vm._v("A szobafoglalás csak a hotel által visszaküldött igazolás esetén érvényes.")])]), _vm._v(" "), _vm._m(13)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "font-size": "16px",
      "font-style": "italic",
      "margin-top": "10px",
      "margin-bottom": "10px"
    }
  }, [_c('span', [_vm._v("Tudja mikor szeretne pihenni de még nem választott a lehetőségek közül?"), _c('br'), _vm._v("Kérjen ajánlatot tőlünk!"), _c('br'), _c('br'), _vm._v("Kérjük küldje el ajánlatkérését az alábbi űrlap kitöltésével!")]), _vm._v(" "), _c('span', [_vm._v("Kérjük küldje el szobafoglalását az alábbi űrlap kitöltésével.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5"
  }, [_c('span', [_vm._v("Az Ön neve *")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5"
  }, [_c('span', [_vm._v("Telefonszám *")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5"
  }, [_c('span', [_vm._v("Email címe *")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5"
  }, [_c('span', [_vm._v("Mikor érkezne? *")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5"
  }, [_c('span', [_vm._v("Melyik nap távozna? *")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5"
  }, [_c('span', [_vm._v("Szobák száma *")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5"
  }, [_c('span', [_vm._v("Szobák típusa *")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5"
  }, [_c('span', [_vm._v("Felnőttek száma *")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5"
  }, [_c('span', [_vm._v("Gyermekek száma")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5"
  }, [_c('span', [_vm._v("Gyermekek életkora")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5"
  }, [_c('span', [_vm._v("Megjegyzés")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5"
  }, [_c('span', [_vm._v("Elfogadom az adatkezelési tájékoztatóban foglaltakat. *")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "font-size": "16px",
      "font-style": "italic"
    }
  }, [_c('span', [_vm._v("Ha kérdése van keressen minket bizalommal a +36 66 547 770-es telefonszámon, vagy a hotel@panoramabekescsaba.hu e-mail címen!")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-773db76d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/main/components/bora/PanoramaForm.vue
// module id = 121
// module chunks = 0 1 2